import React from "react";

const Button = ({ 
  children, 
  onClick, 
  variant = "primary", 
  fullWidth = false, 
  className = "",
  type = "button",
  isLoading = false,
  disabled = false
}) => {
  const baseStyles = "py-3 px-6 rounded-full font-semibold transition-all duration-200 flex items-center justify-center gap-2";
  
  const variants = {
    primary: "bg-[#0044CC] hover:bg-[#003399] text-white shadow-md disabled:bg-blue-300",
    secondary: "bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 disabled:opacity-50",
    outline: "border-2 border-[#0044CC] text-[#0044CC] hover:bg-blue-50 disabled:opacity-50",
    ghost: "text-[#0044CC] hover:bg-blue-50 disabled:opacity-50",
  };

  const widthClass = fullWidth ? "w-full" : "";

  return (
    <button
      type={type}
      className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`}
      onClick={onClick}
      disabled={isLoading || disabled}
    >
      {isLoading ? (
        <span className="flex items-center gap-2">
          <svg className="animate-spin h-5 w-5 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Loading...
        </span>
      ) : children}
    </button>
  );
};

export default Button;
